module.exports = __webpack_public_path__ + "media/images/about-2-b7c699a0ad6c3bc402064cb1fbbd9536.jpg";